export enum CompanysEnum {
    DINHEIRO_SIM = 1,
}